import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GuardService } from './guard.service';
import { Observable } from 'rxjs';
import { AuthService } from '../core/auth/auth.service-api';

@Injectable()
export class UserPermissionsGuard {
  constructor(
    private readonly _srvGuard: GuardService,
    private readonly authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | Observable<boolean> {
    if (route.routeConfig.path === 'super-admin') {
      return this.authService.refreshSuperAdminAccess();
    }
    return this._srvGuard.validateUserPermissions(route.routeConfig.path);
  }
}
